import React, { useEffect, useState } from "react";
import { Form, Col, Row } from "react-bootstrap";
import Select from "react-select";
import axiosClient from "../../../../config/axios.js";

const CraneData = ({
  values,
  errors,
  setFieldValue,
  setFieldTouched,
  isAdmin,
}) => {
  const [gruas, setGruas] = useState([]);
  const [operadores, setOperadores] = useState([]);

  useEffect(() => {
    // Obtener grúas
    axiosClient
      .get("/cranes/all")
      .then((response) => {
        const formattedOptions = response.data.data.map((item) => {
          const etiqueta =
            "#" +
            item.crane_number +
            ", " +
            item.description +
            " (" +
            item.CraneTypes.map((craneType) => craneType.crane_type_name).join(
              ", "
            ) +
            ")";
          return {
            value: item.id,
            label: etiqueta,
            crane_type: item.CraneTypes.map(
              (craneType) => craneType.crane_type_name
            ),
          };
        });
        setGruas(formattedOptions);
      })
      .catch((error) => {
        console.error("Error fetching cranes:", error);
      });

    // Obtener operadores
    axiosClient
      .get("/users/allOperators")
      .then((response) => {
        const formattedOptions = response.data.data
          .filter((operator) => operator.desactivation_date === null)
          .map((operator) => ({
            value: operator.id,
            label:
              operator.name +
              " " +
              operator.first_surname +
              " " +
              operator.second_surname,
            actividad: "",
            encargado: "",
          }));
        setOperadores(formattedOptions);
      })
      .catch((error) => {
        console.error("Error fetching allOperators:", error);
      });
  }, []);

  return (
    <Row>
      <Form.Group as={Col} md="6" className="mb-3">
        <Form.Label>Grúa No.</Form.Label>
        <Select
          name="crane_id"
          options={gruas}
          className={errors.crane_id ? "is-invalid" : ""}
          placeholder="Selecciona una grúa"
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          isClearable={true}
          isSearchable={true}
          value={values.crane_id}
          onChange={(e) => {
            setFieldTouched("crane_id", true);
            setFieldValue("crane_id", e);
          }}
        />
        <Form.Control.Feedback type="invalid">
          {errors.crane_id}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group as={Col} md="6" className="mb-3">
        <Form.Label>Operador</Form.Label>
        <Select
          name="operator_id"
          options={operadores}
          className={errors.operator_id ? "is-invalid" : ""}
          placeholder="Selecciona un operador"
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          isClearable={true}
          isSearchable={true}
          value={values.operator_id}
          onChange={(e) => {
            setFieldTouched("operator_id", true);
            setFieldValue("operator_id", e);
          }}
        />
        <Form.Control.Feedback type="invalid">
          {errors.operator_id}
        </Form.Control.Feedback>
      </Form.Group>
    </Row>
  );
};

export default CraneData;
